import React, { useState } from "react";
import ButtonPlayground from "./components/ButtonPlayground";
import InputPlayground from "./components/InputPlayground";
import CheckboxPlayground from "./components/CheckboxPlayground";
import BadgePlayground from "./components/BadgePlayground";
import StepperPlayground from "./components/StepperPlayground";
import CardPlayground from "./components/CardPlayground";

const Playground = () => {
  const [activeComponent, setActiveComponent] = useState<"button" | "checkbox" | "input"|"badge" | "stepper" |"card">(
    "button"
  );
  const [theme, setTheme] = useState<"light" | "dark">("light");

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <div
      className={`min-h-screen flex font-sans ${
        theme === "light" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <aside className="w-64 bg-gray-50 border-r border-gray-200 p-6">
        <h3 className="text-xl font-semibold mb-4">Components</h3>
        <ul className="space-y-2">
          {["button", "checkbox", "input", "badge", "stepper", "card"].map((component) => (
            <li key={component}>
              <button
                onClick={() => setActiveComponent(component as typeof activeComponent)}
                className="text-blue-600 hover:underline transition-colors"
              >
                {component.charAt(0).toUpperCase() + component.slice(1)}
              </button>
            </li>
          ))}
        </ul>
        <div className="mt-6">
          <button
            onClick={toggleTheme}
            className={`px-4 py-2 rounded ${
              theme === "light" ? "bg-gray-800 text-white" : "bg-gray-300 text-black"
            }`}
          >
            Toggle Theme
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8">
        <h1 className="text-3xl font-bold mb-6">Component Playground</h1>
        {activeComponent === "button" && <ButtonPlayground/>}
        {activeComponent === "input" && <InputPlayground theme={theme} />}
        {activeComponent === "checkbox" && <CheckboxPlayground theme={theme} />}
        {activeComponent === "badge" && <BadgePlayground  />}
        {activeComponent === "stepper" && <StepperPlayground theme={theme} />}
        {activeComponent === "card" && <CardPlayground theme={theme} />}
      </main>
    </div>
  );
};

export default Playground;
